<template>
	<div class="container pt-5">
		<div class="row">
			<div class="col-md-3 m-1 card-category d-flex justify-content-center align-items-center p-3" v-for="category in categories" :key="category['.key']" @click.prevent="to(category.slug)">
				<h5 class="text-center"> {{ category.name }} </h5>
				<figure>
					<img :src="category.background" />
				</figure>
			</div>
		</div>
	</div>
</template>

<script>
	import { categories } from '../../firebase'

	export default {
		firestore() {
      return {
        categories: categories.orderBy('priority')
      }
		},
		methods: {
			to(slug) {
				this.$router.push({ name: 'category-client', params: { slug } })
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/user/Categories.vue